import { render, staticRenderFns } from "./BaseObject.vue?vue&type=template&id=12745531&"
import script from "./BaseObject.vue?vue&type=script&lang=js&"
export * from "./BaseObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports